import RecipeModelFactory from 'services/factory/RecipeModelFactory';
import RecipeContentMapper from './RecipeContentMapper';

const mapFirebaseRefToModel = (id, documentData) => {
  const { createdAt } = documentData;

  const toDate = (timestamp) => new Date(timestamp.seconds * 1000);

  return RecipeModelFactory({
    id,
    ...documentData,
    content: RecipeContentMapper.mapDataModelToUIModel(documentData.content),
    createdAt: toDate(createdAt),
  });
};

const RecipeMapper = {
  mapFirebaseRefToModel,
};

export default RecipeMapper;
